import { render } from "./CatalogPersonSearchDialog.vue?vue&type=template&id=6386da0c"
import script from "./CatalogPersonSearchDialog.vue?vue&type=script&lang=js"
export * from "./CatalogPersonSearchDialog.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Rufiz Huseynzada\\OneDrive - Azerbaijan State Oil and Industry University\\Desktop\\ProgressProjects\\AgentModule\\web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__